import { useCallback, useState } from 'react';

export function useCompanyPolicyTour(storageKey: string) {
    const [run, setRun] = useState(false);

    const startTour = useCallback(() => setRun(true), []);

    const stopTour = useCallback(() => {
        setRun(false);
        if (typeof window !== 'undefined') {
            localStorage.setItem(storageKey, 'true');
        }
    }, [storageKey]);

    const handleJoyrideCallback = useCallback(
        (data: { status?: string; type?: string }) => {
            if (
                data.status === 'finished' ||
                data.status === 'skipped' ||
                data.type === 'tour:end'
            ) {
                stopTour();
            }
        },
        [stopTour],
    );

    return { run, startTour, stopTour, handleJoyrideCallback };
}
